export default "__VITE_ASSET__AK1OVKbF__"